<template>
  <div class="box vh-140">
    <div class="box-header">
      <i class="fa fa-th-large"></i>
      <h3 class="box-title">充值列表</h3>
    </div>
    <div class="box-body">
      <el-row class="margin-bottom-10" gutter="20">
        <el-col :span="10">
          <el-button type="primary" size="small" @click="addrecharge()" plain><i class="fa fa-ra"></i> 充值</el-button>
        </el-col>
        <el-col :span="8" offset="6">
          <el-input size="small" type="text" placeholder="请输入公司名称" v-model="page.param.companyName">
            <el-button slot="append" size="small" @click="doSearch()" type="primary"><i class="fa fa-search"></i> 搜索</el-button>
          </el-input>
        </el-col>
      </el-row>

      <el-table class="list-table" :data="rechargeList" border :stripe="true" style="width: 100%" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{page.pageSize * (page.pageNo - 1) + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="companyName" label="公司"></el-table-column>
        <el-table-column prop="schemeName" label="方案"></el-table-column>
        <el-table-column prop="amount" label="购买套数" width="100"></el-table-column>
        <el-table-column prop="acceptorName" label="受理人" width="120"></el-table-column>
        <el-table-column prop="created" label="充值时间" :formatter="formatTime" width="200"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <page-bar v-model="page" @change="fetchData"></page-bar>
    </div>

      <recharge-save :visible="addDialog" @done="saveFinish"></recharge-save>
  </div>
</template>

<script>
  import {fetchList, remove} from '@/api/manage/recharge'
  import PageBar from '@/components/PageBar.vue'
  import {parseTime} from '@/utils/index'
  import RechargeSave from './RechargeSave'
  import { handleConfirm } from '@utils/confirm'

  export default {
    name: 'ev-recharge',
    components: {
      PageBar, RechargeSave
    },
    created() {
      this.fetchData();
    },
    methods: {
      saveFinish() {
        this.addDialog = false
        this.fetchData()
      },
      fetchData() {
        let {pageNo,pageSize} = this.page
        fetchList({pageNo,pageSize}).then(resp => {
          let data = resp.data.result || {}
          this.page = data
          this.rechargeList = data.records;
        })
      },
      formatTime: function (row, column, val) {
        return parseTime(val);
      },
      addrecharge() {
        this.addDialog = true
      },
      doSearch(){
        this.page.pageNo = 1
        this.fetchData()
      },
    },
    data: function () {
      return {
        addDialog: false,
        page: {
          pageSize: 20,
          pageNo: 1,
          param:{
            companyName:''
          }
        },
        rechargeList: [],
        recharge: {}
      }
    }
  }
</script>
